import {
    isEqual as _isEqual
} from '@lodash';
import Vue from 'vue';
import Router from 'vue-router';
import PageNotFound from '@pages/PageNotFound.vue';
import PageNotAuthorized from '@pages/PageNotAuthorized.vue';
import InfoPage from '@pages/InfoPage.vue';
import routes from '@countryRouter/routes';
import {
    updateTitle,
    updateMetaTags,
    getDefaultLayout,
} from '@app/router/utils';
import { isMobile } from '@app/layout';
import store from '../store';
import {
    links,
    routeNames,
    titles,
} from './constants';

Vue.use(Router);

export {
    links,
    routeNames,
};

const router = new Router({
    mode: 'history',
    scrollBehavior(to, from) {
        if (from.name === to.name && _isEqual(from.params, to.params)) {
            return undefined;
        }
        return { x: 0, y: 0 };
    },
    routes: [
        ...routes,
        {
            path: links.info,
            name: routeNames.info,
            components: getDefaultLayout(InfoPage),
            meta: {
                title: titles.info
            },
        },
        {
            path: links.page_401,
            name: routeNames.notAuthorized,
            components: getDefaultLayout(PageNotAuthorized),
            meta: {
                title: titles.notAuthorized
            },
        },
        {
            path: '*',
            name: 'Not Found',
            components: getDefaultLayout(PageNotFound),
            meta: {
                title: titles.notFound
            },
        }
    ]
});

// This callback runs before every route change, including on page load.
router.beforeEach((to, from, next) => {
    store.dispatch('ui/help/reset');
    if (isMobile()) {
        if (to.name === routeNames.landing && from.name === routeNames.sportOffer
            || to.name === routeNames.sportOffer && from.name === routeNames.landing) {
                // do nothing beacuse they're basically the same page
        } else if (to.name !== from.name) {
            store.dispatch('ui/mobile/closeSidebar');
        }
    }
    updateTitle(to);
    updateMetaTags(to);
    next();
});

export default router;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/app/router/index.ts